//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { getParent, getSnapshot, types } from "mobx-state-tree";

export const TeachingProfileStore = types
  .model("TeachingProfileStore", {
    specialNeeds: types.optional(types.array(types.string), []),
    tutorDisabilities: types.optional(types.array(types.string), []),
  })
  .views((self) => {
    return {
      get rootStore() {
        return getParent(self, 1);
      },
      get completed() {
        return this.rootStore.others.completed;
      },
      get rawValues() {
        return Array.from(new Set(getSnapshot(self.specialNeeds)));
      },
      get formValues() {
        return getSnapshot(self);
      },
    };
  })
  .actions((self) => {
    return {
      setSpecialNeeds(v) {
        self.specialNeeds = v;
      },
      setTutorDisabilities(u) {
        self.tutorDisabilities = u;
      },
    };
  });
